import { ColorsDark, ColorsLight, Theme } from 'libs/ui/theme';

export const getColor = (
  theme: Theme,
  { light, dark }: { light: ColorsLight; dark: ColorsDark }
) => (theme.palette.mode === 'light' ? light : dark);
